module.exports = __webpack_public_path__ + "static/img/clqd3.3b0bcbd2.png";